export default "__VITE_ASSET__BIKN68VB__"